import { Typography, Button, Grid, CardContent, Card } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useCurrentAppRoute } from '../../hooks/app-route-hooks';
import { useAuthHelper } from '../AuthContextProvider';

import { pushAppRoute } from '../../data/domain/route-manager';
import { useToasts } from '../../data/DataProviders/ToastProvider';
import { ContentContainer } from '../ContentContainer';
import { GenericToolbar } from '../GenericToolbar';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { isRecordFound, useSelectedOrganizationData } from '../../hooks/data-hooks';
import { ActivationIdDialog } from '../../components/ActivationIdDialog/ActivationIdDialog';
import { Thunks } from '../../actions';
import { isDataLoaded } from '../../types';
import { ConfirmationPopUp } from '../ConfirmationPopUp/ConfirmationPopUp';
import { GetSubscriptionActions } from '../../actions/actions/get-subscription-actions';
import { GetSubscriptionSelectors } from '../../selectors/get-subscription-selectors';
import SettingsIcon from '@mui/icons-material/Settings';
import Leaf from '@brightlayer-ui/icons-mui/Leaf';
import { useGetPartNumberDetails } from '../../data/DataProviders/GetPartNumberProvider';
import { CONTACT_EMAIL, CONTACT_PHONENO, EXPLORE_LINK_TEXT, PLAN_LINK } from '../../constants';
import { ShoppingCart } from '@mui/icons-material';
import { Selectors } from '../../selectors';
export const AcquireSubscription: React.FC = () => {
    const { t } = useLanguageLocale();
    const selectedOrganization = useSelectedOrganizationData();
    const currentAppRoute = useCurrentAppRoute();
    const dispatch = useDispatch();
    const meshSubscriptionDetails = useGetPartNumberDetails();
    const history = useHistory();
    const authHelper = useAuthHelper();
    const mappingState = useSelector(GetSubscriptionSelectors.mappingSiteIdActivationId);
    const subscriptionState = useSelector(GetSubscriptionSelectors.getSubscription);
    const createEntitlementState = useSelector(GetSubscriptionSelectors.createEntitlement);
    const [showDialog, setShowDialog] = useState(false);
    const [selectedOption, setSelectedOption] = useState('');
    const [mappingValue, setValue] = useState('')
    const subType = currentAppRoute.type === 'AcquireSubscription' ? currentAppRoute.subType : '';
    const { addToast } = useToasts();
    const [openDelete, setOpenDelete] = React.useState(false);
    const [openTrialDailog, setOpenTrialDailog] = React.useState(false);
    const email = useSelector(Selectors.User.email);
    const [activationCodeSent, setActivationCodeSent] = useState(false);
    const [entitlementSuccessRes, setEntitlementSuccessRes] = useState(false);

    const styles = {
        largeIcon: {
            width: 100,
            height: 100,
        },
    };
    useEffect(() => {
        if (currentAppRoute.type === 'AcquireSubscription') {
            const GetPartData = {
                siteId: currentAppRoute.siteId,
            };
            dispatch(Thunks.GetSubscription.GetPartNumberDetails(GetPartData, authHelper, addToast));
        }
    }, [meshSubscriptionDetails]);
    const closePopUp = (value: string): void => {
        setValue(value)
        setShowDialog(false);
    };

    const closeOkayPopUp = (): void => {
        setOpenDelete(false);

    };
    const closeTrailPopUp = (): void => {
        setOpenTrialDailog(false);
    };
    const closeSuccessPopUp = (): void => {
        setActivationCodeSent(false);

    };

    React.useEffect(() => {
        setEntitlementSuccessRes(createEntitlementState.entitlementSuccess);
    }, [createEntitlementState.entitlementSuccess]);

    const CreateEntitlement = (): void => {
        if (email) {
            const entitlementeData = {
                emailId: email
            };

            dispatch(Thunks.GetSubscription.CreateEntitlement(entitlementeData, authHelper, addToast));
        }
        closeTrailPopUp();
        setActivationCodeSent(true);
    };


    const backtoProfile = (): void => {
        dispatch(GetSubscriptionActions.mappingSiteIdActivationIdUnmounted());
        if (currentAppRoute.type === 'AcquireSubscription')
            pushAppRoute(history, {
                type: 'MeshDeviceProfile',
                orgId: currentAppRoute.orgId,
                locationId: currentAppRoute.locationId,
                siteId: currentAppRoute.siteId,
                deviceId: currentAppRoute.deviceId,
            });
    };


    //Catch event here and open the dialog
    const openActivationIdDialog = (dialogType: string) => () => {
        setSelectedOption(dialogType);
        dispatch(GetSubscriptionActions.mappingSiteIdActivationIdUnmounted());
        setShowDialog(true);
    };

    const openContactSupportDialog = () => () => {
        setOpenDelete(true);
    };

    useEffect(() => {
        dispatch(GetSubscriptionActions.getSubscriptionUnmounted());
        if (!subscriptionState.getSubscriptionLinkLoading && subscriptionState.getSubscriptionLinkSuccess) {
            const subscriptionUrl = subscriptionState.subscriptionUrl;
            window.open(subscriptionUrl, '_blank');
        }
    }, [subscriptionState.getSubscriptionLinkSuccess]);

    return (
        <>
            {isRecordFound(selectedOrganization) && isDataLoaded(meshSubscriptionDetails) && (
                <>
                    <GenericToolbar
                        showBackButton
                        backButtonOnClick={(): void => {
                            if (currentAppRoute.type === 'AcquireSubscription')
                                pushAppRoute(history, {
                                    type: 'MeshDeviceProfile',
                                    orgId: currentAppRoute.orgId,
                                    locationId: currentAppRoute.locationId,
                                    siteId: currentAppRoute.siteId,
                                    deviceId: currentAppRoute.deviceId,
                                });
                        }}
                        title="Acquire Subscription"
                    />

                    <ContentContainer>
                        <Grid style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button
                                variant="contained"
                                color="primary"
                                data-testid="activate-id"
                                onClick={openActivationIdDialog('ActivationId')}
                            >
                                Activate Subscription ID
                            </Button>
                        </Grid>
                        <Grid>
                            <Grid container spacing={4} justifyContent="center">
                                <Grid item xs={12} sm={4} mt={3} mb={3} data-testid="trial-subscription">
                                    <Card variant="outlined">
                                        <React.Fragment>
                                            <CardContent style={{ flexGrow: 1 }}>
                                                <Typography align="center">
                                                    <SettingsIcon sx={{ fontSize: 100 }} />
                                                    <Typography variant="h5" component="div">
                                                        Trial
                                                    </Typography>
                                                    <Typography variant="body2">
                                                        Group Control and Insights for
                                                        Limited Time <br></br> and Group Size.
                                                        <br /> <br />
                                                        <Button
                                                            id="Trial"
                                                            data-testid="trial-btn"
                                                            onClick={() => { setOpenTrialDailog(true) }}
                                                            startIcon={
                                                                createEntitlementState.entitlementLoading ? (
                                                                    <></>
                                                                ) : (
                                                                    <ShoppingCart
                                                                        style={{ color: subType === 'CHAMP-BASIC' ? '#A9A9A9' : '#007BC1' }}
                                                                    />
                                                                )
                                                            }
                                                            disabled={subType === 'CHAMP-BASIC' ? true : false}
                                                            value="Trial"
                                                            variant='outlined'
                                                            color="primary"
                                                            size="medium"
                                                        >
                                                            Purchase
                                                        </Button>
                                                    </Typography>
                                                </Typography>
                                            </CardContent>
                                        </React.Fragment>
                                    </Card>
                                </Grid>

                                <Grid item xs={12} sm={4} mt={3} mb={3} data-testid="advanced-subscription">
                                    <Card variant="outlined" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                                        <React.Fragment>
                                            <CardContent style={{ flexGrow: 1 }}>
                                                <Typography align="center">
                                                    <Leaf style={styles.largeIcon} />
                                                    <Typography variant="h5" component="div">
                                                        Advanced
                                                    </Typography>
                                                    <Typography variant="body2">
                                                        Group Control and Insights.
                                                        <br /> <br />
                                                        <Button
                                                            id="Advanced"
                                                            data-testid="advanced-btn"
                                                            variant='outlined'
                                                            color="primary"
                                                            size="medium"
                                                            onClick={openContactSupportDialog()}
                                                            startIcon={
                                                                <ShoppingCart
                                                                    style={{ color: subType === 'BLI-CH-DL-ADV' ? '#A9A9A9' : '#007BC1' }}
                                                                />}
                                                            disabled={subType === 'BLI-CH-DL-ADV' ? true : false}
                                                        >
                                                            Purchase
                                                        </Button>
                                                    </Typography>
                                                </Typography>
                                            </CardContent>
                                        </React.Fragment>
                                    </Card>
                                </Grid>
                            </Grid>

                        </Grid>
                    </ContentContainer>
                    {openTrialDailog && (
                        <ConfirmationPopUp
                            title={t('ACTIVATE_SUBSCRIPTION.ACTIVATION_SUBSCRIPTION_ID_TITLE')}
                            body={
                                <div style={{ wordWrap: 'break-word' }}>
                                    <Typography variant="body2" component="p" style={{ marginBottom: 50 }}>
                                        {t('ACTIVATE_SUBSCRIPTION.ACTIVATE_ACTIVATION_ID')}
                                    </Typography>
                                </div>
                            }
                            okButtonText={'OK'}
                            show={true}
                            handleOk={CreateEntitlement}
                            okButtonShow={true}
                            closeDialog={closeTrailPopUp}
                            cancelButtonsShow={true}
                            cancelButtonText='BACK'
                            width="xs"
                        ></ConfirmationPopUp>)}
                    {showDialog && (
                        <ActivationIdDialog
                            show={showDialog}
                            closeDialog={closePopUp}
                            selectedOption={selectedOption}
                            mappingValue={mappingValue}
                        ></ActivationIdDialog>
                    )}
                    {openDelete && (
                        <ConfirmationPopUp
                            title={'Contact Eaton'}
                            body={
                                <div style={{ wordWrap: 'break-word' }}>
                                    <Typography variant="body1" data-testid="contact-email">
                                        For feedback,question or support please email us at{' '}
                                        <a href={`mailto:${CONTACT_EMAIL}`} style={{ color: '#007BC1' }}>
                                            {CONTACT_EMAIL}
                                        </a>
                                    </Typography>
                                    <Typography variant="body1" data-testid="contact-phone">
                                        For 24/7 technical support, please call
                                        <br></br>
                                        <a href={`tel:${CONTACT_PHONENO}`} style={{ color: '#007BC1' }}>
                                            {CONTACT_PHONENO}
                                        </a>
                                    </Typography>
                                    <Typography variant="body1" data-testid="contact-phone">
                                        Explore our subscription plans by clicking the link below
                                        <br></br>
                                        <a href={`${PLAN_LINK}`} target="_blank" rel="noopener noreferrer" style={{ color: '#007BC1' }}>
                                            {EXPLORE_LINK_TEXT}
                                        </a>
                                    </Typography>
                                </div>
                            }
                            okButtonText={'OK'}
                            show={openDelete}
                            okButtonShow={true}
                            handleOk={(): void => {
                                closeOkayPopUp()
                            }}
                            width="xs"


                        />
                    )}
                    {mappingState.mappingSuccess && (
                        <ConfirmationPopUp
                            title={t('SUBSCRIPTION.ACTIVATION_ID_VALID')}
                            body={
                                <div style={{ wordWrap: 'break-word' }}>
                                    <Typography variant="body2">
                                        Subscription Type: {mappingState.subscriptionType}
                                    </Typography>
                                    <Typography variant="body2">
                                        Expire Date:{' '}
                                        {mappingState.expirationDate
                                            ? mappingState.expirationDate.substring(0, 10)
                                            : ''}
                                    </Typography>
                                    <Typography variant="body2">Quantity:{mappingState.quantity}</Typography>
                                </div>
                            }
                            okButtonText={'OK'}
                            show={true}
                            handleOk={backtoProfile}
                            okButtonShow={true}
                            width="xs"
                        ></ConfirmationPopUp>
                    )}
                    {activationCodeSent && entitlementSuccessRes && (
                        <ConfirmationPopUp
                            title={t('SUBSCRIPTION.SUCCESS')}
                            body={
                                <div style={{ wordWrap: 'break-word' }}>
                                    <Typography variant="body2" component="p" style={{ marginBottom: 50 }}>
                                        {t('SUBSCRIPTION.SENT_ACTIVATION_ID')}
                                    </Typography>
                                </div>
                            }
                            okButtonText={'OK'}
                            show={activationCodeSent}
                            handleOk={closeSuccessPopUp}
                            okButtonShow={true}
                            width="xs"
                        ></ConfirmationPopUp>
                    )}
                </>
            )}
        </>
    );
};
